// src/features/ui/tab.component.tsx
import styled from "styled-components";

export const TabContainer = styled.div<{ styles?: React.CSSProperties }>`
  display: flex;
  background: #ebf5ff;
  width: 347px;
  padding: 5px;
  border-radius: 8px;
  ${({ styles }) => styles && { ...styles }} /* Apply custom styles */
`;

export const TabButton = styled.div<{ active: boolean; styles?: React.CSSProperties }>`
  flex: 1; /* Equal width for all tabs */
  text-align: center; /* Center text */
  border-right: ${(props) => (props.active ? "none" : "1px solid #bfc0c0")};
  background: ${(props) => (props.active ? "#1890FF" : "transparent")};
  color: ${(props) => (props.active ? "#fff" : "#4F5D75")};
  cursor: pointer;
  font-style: normal;
  font-weight: 400;
  font-size: 11px;
  padding: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-bottom-right-radius: ${(props) => (props.active ? "0" : "8px")};

  &:last-child {
    border-right: none;
    border-bottom-right-radius: 0;
  }

  ${({ styles }) => styles && { ...styles }} /* Apply custom styles */
`;

export const TabPanel = styled.div<{ active: boolean; styles?: React.CSSProperties }>`
  display: ${(props) => (props.active ? "block" : "none")};
  // border: 1px solid #065c5a2e;
  border-top: none;
  padding: 12px 16px;
  ${({ styles }) => styles && { ...styles }} /* Apply custom styles */
`;
